<template>
  <div class="row g-0 justify-content-center">
    <div class="col-sm-8 col-xl-6">
      <div v-if="message" class="alert d-flex align-items-center alert-dismissable alert-danger" role="alert">
        <div class="flex-00-auto">
          <i class="fas fa-exclamation-circle"></i>
        </div>
        <div class="flex-fill ml-3">
          <p class="mb-0">{{ message }}</p>
        </div>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="form-group">
        <bs-input type="email" label="Email*" name="email" classname="form-control-alt" v-model="email"></bs-input>
      </div>
      <div class="form-group">
        <bs-input type="password" label="Wachtwoord*" name="password" classname="form-control-alt" v-model="password"></bs-input>
      </div>
      <div class="form-group">
        <bs-input label="Voornaam*" name="firstname" classname="form-control-alt" v-model="firstname"></bs-input>
      </div>
      <div class="form-group">
        <bs-input label="Achternaam*" name="lastname" classname="form-control-alt" v-model="lastname"></bs-input>
      </div>
      <div class="form-group">
        <bs-input label="Bedrijfsnaam" name="company" classname="form-control-alt" v-model="company"></bs-input>
      </div>
      <div class="form-group">
        <bs-input label="KVK" name="coc" classname="form-control-alt" v-model="coc"></bs-input>
      </div>
      <div class="form-group">
        <bs-input label="Adres*" name="address" classname="form-control-alt" v-model="address"></bs-input>
      </div>
      <div class="form-group">
        <bs-input label="Postcode*" name="postal_code" classname="form-control-alt" v-model="postal_code"></bs-input>
      </div>
      <div class="form-group">
        <bs-input label="Woonplaats*" name="city" classname="form-control-alt" v-model="city"></bs-input>
      </div>
      <div class="form-group">
        <bs-select
          label="Land*"
          name="country"
          classname="js-select2 form-control-alt"
          :options="
            Object.keys(countries)
              .filter((key) => countries[key])
              .map((key) => {
                return {
                  name: countries[key],
                  value: key,
                };
              })
              .sort((a, b) => {
                return a['name'] - b['name'];
              })
          "
          v-model="country"
        ></bs-select>
      </div>
      <div class="form-group">
        <bs-input label="Btw nummer" name="vat" classname="form-control-alt" v-model="vat" v-if="country !== 'NL'"></bs-input>
      </div>
      <div class="form-group">
        <bs-input label="Telefoonnummer" name="phone" classname="form-control-alt" v-model="phone"></bs-input>
      </div>
      <div class="form-group">
        <bs-select
          label="Nieuwsbrief ontvangen?"
          name="newsletter"
          classname="js-select2 form-control-alt"
          :empty="false"
          :options="[
            { name: 'Ja', value: true },
            { name: 'Nee', value: false },
          ]"
          v-model="newsletter"
        ></bs-select>
      </div>
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-secondary" v-on:click.prevent="login"><i class="fa fa-angle-left mr-1"></i> Terug</button>
        <button
          type="button"
          class="btn btn-primary g-recaptcha"
          :data-sitekey="recaptcha_key"
          data-callback="myRecaptchaMethod"
          data-action="submit"
        >
          Registreren <i class="fa fa-angle-right ml-1"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
export default {
  props: ['countries', 'recaptcha_key'],
  data: () => {
    return {
      errors: [],
      message: null,

      email: null,
      password: null,
      firstname: null,
      lastname: null,

      company: null,
      coc: null,
      address: null,
      postal_code: null,
      city: null,
      country: 'NL',
      vat: null,
      phone: null,
      newsletter: 'true',
    };
  },
  mounted() {
    window.myRecaptchaMethod = this.register;
  },
  methods: {
    login: function() {
      window.location.href = route('login');
    },
    register: function(recaptcha_response) {
      this.errors = [];
      this.message = null;

      axios
        .post(route('register'), {
          email: this.email,
          password: this.password,
          password_confirmation: this.password,
          firstname: this.firstname,
          lastname: this.lastname,
          company: this.company,
          coc: this.coc,
          address: this.address,
          postal_code: this.postal_code,
          city: this.city,
          country: this.country,
          vat: this.vat,
          phone: this.phone,
          newsletter: this.newsletter === 'true',
          'g-recaptcha-response': recaptcha_response,
        })
        .then((response) => {
          if (response.status == 201) {
            window.location.replace(route('home'));
          }
        })
        .catch((error) => {
          if (error.response && error.response.data) {
            if (error.response.data.errors) {
              this.errors = error.response.data.errors;

              if (this.errors['email'] || this.errors['password'] || this.errors['firstname'] || this.errors['lastname']) {
                this.activeTab = 1;
              } else {
                this.activeTab = 2;
              }
            } else if (error.response.data.message) {
              this.message = error.response.data.message;
            }
          }
        });
    },
  },
};
</script>
<style scoped></style>
